import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TabsPage } from '../pages/tabs/tabs';
import { Component, ViewChild } from '@angular/core';
import { Platform, Nav,NavParams, Events,ModalController ,LoadingController,AlertController,App} from 'ionic-angular';
import { HomePage } from '../pages/home/home';
import { ContactPage } from '../pages/contact/contact';
import { AboutPage } from '../pages/about/about';
import { LoginPage } from '../pages/login/login';

import { BranchLocatorPage } from '../pages/branch-locator/branch-locator';
import { CalculatorPage } from '../pages/calculator/calculator';
import { CalculatorsPage } from '../pages/calculators/calculators';

import { FaqPage } from '../pages/faq/faq';
import { IntrestRateMovementPage } from '../pages/intrest-rate-movement/intrest-rate-movement';
import { OffersPage } from '../pages/offers/offers';
import { OtherProductPage } from '../pages/other-product/other-product';
import { PmayPage } from '../pages/pmay/pmay';
import { ReferAFriendPage } from '../pages/refer-a-friend/refer-a-friend';
import { HTTP } from '@ionic-native/http';
// import { OneSignal } from '@ionic-native/onesignal';
import OneSignal from 'onesignal-cordova-plugin';
import { CommonProvider } from '../providers/common/common';
import { Storage } from '@ionic/storage';

declare var cordova:any;
// declare var jailbreakdetection:any;
declare var IRoot:any;
declare var window:any;
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  
  logOutObject:any={title: "Logout",component: LoginPage}
  rootPage: any = localStorage.getItem("token")?HomePage:LoginPage;

  pages: Array<{icon:string,title: string, component: any,fn?:any}>;

  //rootPage1:any = TabsPage;
  user:any;
  cust_name:any;
  cust_email:any;
  cust_number:any;
  newMessage:any = "Are you looking for Home Loan / Loan Against Property or do you require assistance regarding your existing loan? Simply Click on this message, we are online and ready to help.";
  // server_url:any = `https://txcontact5.sammaancapital.com/txnjswebchat`;
  server_url:any = `https://txchat.sammaancapital.com/txnjswebchat`;
  
  app_name:any = `chat_support`
   
  isIframeVisible:any = false;
  
  chatPopTime:any = 1000 * 10; // in sec (30 sec);
  getAllLoanDetails:any=[]; 

  
  constructor( private storage: Storage,private loadingCtrl:LoadingController, private cp: CommonProvider,platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,
    public events:Events,public modalCtrl: ModalController,private http:HTTP,public alertCtrl: AlertController,private app:App) {
    this.checkSession();
    
    this.pages = [
        {icon:"../assets/icon/ico-static-lhs-home.svg",  title: 'Home', component: HomePage ,fn:"true"},
        {icon:"../assets/icon/ico-static-lhs-about-us.svg",  title: 'About Us', component: AboutPage },
        {icon:"../assets/icon/ico-static-lhs-contact-us.svg",  title: "Contact Us", component: ContactPage,fn:"true"},
        {icon:"../assets/icon/ico-static-lhs-branch-locator.svg",  title: 'Branch Locator', component: BranchLocatorPage },
        
        // {icon:"cog",  title: 'Intrest Rate Movement', component: IntrestRateMovementPage },
        {icon:"../assets/icon/ico-static-lhs-faqs.svg",  title: 'Faq', component: FaqPage },
        // {icon:"cart",  title: 'Other Product', component: OtherProductPage },
        // {icon:"cafe",  title: 'Offers', component: OffersPage },
        
        // {icon:"person",  title: 'PMAY', component: PmayPage },
        {icon:"../assets/icon/ico-static-lhs-calculators.svg",  title: 'Calculators', component: CalculatorsPage ,fn:"true"},
        
        // {icon:"../assets/icon/ico-static-lhs-refer-friend.svg",  title: "Refer A Friend", component: ReferAFriendPage},
         
        {icon:"../assets/icon/ico-static-lhs-logout.svg",  title: "Login", component: LoginPage},
       
      ];
      this.events.subscribe('user:created', (user, time) => {
         
        this.user = user
         
        if(user && localStorage.getItem("token")){
          this.pages = [
                        {icon:"../assets/icon/ico-static-lhs-home.svg",  title: 'Home', component: HomePage,fn:"true" },
                        {icon:"../assets/icon/ico-static-lhs-about-us.svg",  title: 'About Us', component: AboutPage },
                        {icon:"../assets/icon/ico-static-lhs-contact-us.svg",  title: "Contact Us", component: ContactPage,fn:"true"},
                        {icon:"../assets/icon/ico-static-lhs-branch-locator.svg",  title: 'Branch Locator', component: BranchLocatorPage },
                        {icon:"../assets/icon/ico-static-lhs-faqs.svg",  title: 'Faq', component: FaqPage },
                        {icon:"../assets/icon/ico-static-lhs-calculators.svg",  title: 'Calculators', component: CalculatorsPage,fn:"true" },
                        {icon:"../assets/icon/ico-static-lhs-logout.svg",  title: "Logout", component: LoginPage,fn:"true"}
                      ]

            
           
        }else{
              this.pages = [
                        {icon:"../assets/icon/ico-static-lhs-home.svg",  title: 'Home', component: HomePage ,fn:"true"},
                        {icon:"../assets/icon/ico-static-lhs-about-us.svg",  title: 'About Us', component: AboutPage },
                        {icon:"../assets/icon/ico-static-lhs-contact-us.svg",  title: "Contact Us", component: ContactPage,fn:"true"},
                        {icon:"../assets/icon/ico-static-lhs-branch-locator.svg",  title: 'Branch Locator', component: BranchLocatorPage },
                        {icon:"../assets/icon/ico-static-lhs-faqs.svg",  title: 'Faq', component: FaqPage },
                        {icon:"../assets/icon/ico-static-lhs-calculators.svg",  title: 'Calculators', component: CalculatorsPage },
                        {icon:"../assets/icon/ico-static-lhs-logout.svg",  title: "Login", component: LoginPage},
                       ];
              this.hideIframe()
            }
      });
    // used for an example of ngFor and navigation
      
   
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.hide();
      splashScreen.hide(); 
       setInterval(()=>{
         this.checkChat();
        },5000)
    });
  }
   
  clickOnChatButton(){
    setTimeout(()=>{
               
              var chatDiv = document.getElementById("chatMainDiv");
              if(chatDiv){
                document.getElementById("chatMainDiv").style.display = "block";
                var cust_number = localStorage.getItem("cust_number");
                var cust_name = localStorage.getItem("cust_name")
                var cust_email = localStorage.getItem("cust_email")
                var getAllLoanDetails = JSON.parse(localStorage.getItem("getAllLoanDetails"));
                this.cust_number=cust_number;
                this.cust_name=cust_name;
                this.cust_email=cust_email;
                this.getAllLoanDetails=getAllLoanDetails;
                if(localStorage.getItem("getAllLoanDetails")){
                   this.callWebChat(this.cust_name, this.cust_email, this.cust_number,this.getAllLoanDetails);
              
                }
               }
            },3000)
  }
  checkChat = function () {
      setTimeout(()=>{
        
          const img:any = document.querySelector(".profile_div");
         
          if (localStorage.getItem('getAllLoanDetails')) {
              
              img.style.display = "block";
              document.getElementById("chatMainDiv").style.display = "block";
          }
          else {
              
              img.style.display = "none";
              document.getElementById("chatMainDiv").style.display = "none";
          }
       },2000)
    }
  showAlert(msg,title) {
    const alert = this.alertCtrl.create({
      title:title,
      subTitle: msg,
      buttons: [{
          text: 'Ok',
          handler: data => {
             
          }
        }]
    });
    alert.present();
  }

  showSessionAlert(msg,title) {
    const alert = this.alertCtrl.create({
      title:title,
      subTitle: msg,
      cssClass: 'profalert',
      buttons: [{
          text: 'Ok',
          handler: data => {
            this.hideIframe();
            localStorage.clear();
            this.nav.setRoot(LoginPage)
          }
        }]
    });
    alert.present();
  }

  checkSession(){
    var date = new Date();
    if(localStorage.getItem("token")){
      if(localStorage.getItem("_current")){
                var cTime = date.getTime()-parseInt(localStorage.getItem("_current"))
                if(cTime>300000){
                    this.showSessionAlert("Your session has expired.Please login again!","Warning !")
                }else{
                    localStorage.setItem("_current",date.getTime().toString())
                }
                
            }else{
              localStorage.clear();
              // sessionStorage.clear();
              this.nav.setRoot(LoginPage);
              this.hideIframe();
              window.location.Reload();
            }
          }
        }
  /*Chat boat*/
        

         callWebChat(cust_name, cust_email, cust_number,lanArr) {
             
            //const messageDiv = document.getElementById('helpMessage');
            //messageDiv.textContent = this.newMessage;
            const profileDiv = document.getElementById("profile_div");
            fetch(`${this.server_url}/check?app_name=${this.app_name}`, { method: 'HEAD' })
            .then(response => {
                 
                console.log(response)
                if (response.ok) {
                    console.log('response ok')
                    profileDiv.style.display = "block";
                } else {
                    console.log("Response not ok")
                    profileDiv.style.display = "none";
                }
            })
            .catch(error => {
                console.error('Error:', error);
                profileDiv.style.display = "none";
            });

            const iframe = document.querySelector(".floating-iframe");
            const img = document.querySelector(".profile_div")
            const style = document.createElement('style');


            this.isIframeVisible = false;
            var that=this;
            document.getElementById("profile_div").addEventListener("click", function () {
                
                    if (!that.isIframeVisible) {
                        that.showIframe();
                    } else {
                        that.hideIframe();
                    }
                 
            });

            window.addEventListener("message", function (event) {
                if (event.data === "closeIframe") {
                    that.hideIframe();
                }
            });

             

           // const helpMessage = document.getElementById("helpMessage");
            const imgProfile = document.querySelector(".imgProfile");

            // setTimeout(function() {
            //     helpMessage.style.display = "block";
            //     helpMessage.style.animation = "pop-animation 0.5s ease-in-out";
            //     imgProfile.classList.remove("pulse");
            // }, this.chatPopTime * 0.2);

            setTimeout(function() {
                if (!this.isIframeVisible) {
                    that.showIframe();
                }
            }, this.chatPopTime);
            // this.setCSSForMessage(this.newMessage);
        }
        hideIframe() {

                const iframe:any = document.querySelector(".floating-iframe");
                const img:any = document.querySelector(".profile_div")
                const style:any = document.createElement('style');
                iframe.src = "";
                iframe.style.display = "none";
                this.isIframeVisible = false;
                if(localStorage.getItem('getAllLoanDetails')){
                  img.style.display = "block";
                }
                else{
                  img.style.display = "none";
                  document.getElementById("chatMainDiv").style.display = "none";
                }
                

            }

        setCSSForMessage(message) {
                const messageDiv:any = document.getElementById('helpMessage');
                const maxLength:any = 35;

                if (message.length > maxLength) {
                    messageDiv.style.fontSize = 'min(max(0.4rem, 1vw), 0.6rem)';
                } else {
                    messageDiv.style.fontSize = 'min(max(0.6rem, 2vw), 0.8rem)';
                }
            }
        showIframe() {
                const iframe:any = document.querySelector(".floating-iframe");
                const img:any = document.querySelector(".profile_div")
                const style:any = document.createElement('style');
                const currentURL:any = window.location.href;
                const urlParams:any = new URLSearchParams(window.location.search);
                // let iframeSrc = `${this.server_url}?app_name=${this.app_name}&tx_name=${this.cust_name}&tx_number=${this.cust_number}&tx_email=${this.cust_email}`; 
                // tx_lan1 = lan1,lan1-status,customer-name,registered-mobile-no,registered-email
                 
                const data={data:JSON.parse(localStorage.getItem("arrDataForChat"))}
                // console.log("data",data);
                let loading = this.loadingCtrl.create({
                       content: 'Please wait...'
                      });
                        
                  let request:any={} 
                   request=data;
                   let iframeSrc:any ='';
                  this.cp.postChatboat(loading,request).then((resp:any)=>{
                     loading.dismiss();
                     try{
                      // console.log(resp,"jkjkhk");
                      iframeSrc = `${this.server_url}?app_name=${this.app_name}&ref_id=${JSON.parse(resp).ref_id}`;
                      // Append all parameters from the current URL to the iframe source URL
                        for (const [key, value] of urlParams.entries()) {
                            iframeSrc += `&${key}=${value}`;
                        }   

                        // Set the iframe source URL
                        iframe.src = iframeSrc;

                        // Display the iframe and hide the profile image
                        iframe.style.display = "block";
                        this.isIframeVisible = true;
                        img.style.display = "none";

                     }catch(e){
                       // that.veiwLead(JSON.parse(this.navParams.data).Payload.lead.leadid)
                     } 
                       
                  })
                 

                
            }
  /*end chat boat*/
  showAlertForCheckVersion(msg,title,link) {
    const alert = this.alertCtrl.create({
      title:title,
      subTitle: msg,
      enableBackdropDismiss: false, 
      buttons: [{
          text: 'Ok',
          handler: data => {
            window.location.href=link;
              
          }
        }]
    });
    alert.present();
  }
  checkAppVersion(){
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          //loading.present();
      // var that = this;   
      let request:any={} 
      request.version='4.1.9';
      request.platform='ANDROID'
      this.cp.checkLatestVersion(loading,request).then((resp:any)=>{
         loading.dismiss();
         try{
          // console.log(JSON.parse(resp));
           if(JSON.parse(resp).Message == 'FAILURE'){
            if(JSON.parse(resp).link){
              this.showAlertForCheckVersion(JSON.parse(resp).Displaymessage,"Update",JSON.parse(resp).link)
            }else{
              this.showAlertForCheckVersion(JSON.parse(resp).Displaymessage,"Update","https://www.google.com")
            }
              
              return false;
            }else{
              
                
            }

         }catch(e){
           // that.veiwLead(JSON.parse(this.navParams.data).Payload.lead.leadid)
         } 
           
      })
  }
  presentModal() {
    const modal = this.modalCtrl.create(ContactPage,{showBackdrop: false,
            enableBackdropDismiss: false});
    modal.present();
  }
  openPage(page,clickStatus?:any) {
    if(localStorage.getItem("token")){
      let user:any=localStorage.getItem("token");
      this.events.publish('user:created',user , Date.now());
    }
    
    if(!clickStatus){
      this.nav.setRoot(page.component);
    }else{
      if(page.title=="Logout"){
        localStorage.clear();
        this.storage.clear();
        this.storage.remove("token");
        this.events.unsubscribe("user");
        //this.hideIframe();
        this.user="";
        this.pages = [
            {icon:"../assets/icon/ico-static-lhs-home.svg",  title: 'Home', component: HomePage,fn:"true" },
            {icon:"../assets/icon/ico-static-lhs-about-us.svg",  title: 'About Us', component: AboutPage },
            {icon:"../assets/icon/ico-static-lhs-contact-us.svg",  title: "Contact Us", component: ContactPage,fn:"true"},
            {icon:"../assets/icon/ico-static-lhs-branch-locator.svg",  title: 'Branch Locator', component: BranchLocatorPage },
            
            // {icon:"cog",  title: 'Intrest Rate Movement', component: IntrestRateMovementPage },
            {icon:"../assets/icon/ico-static-lhs-faqs.svg",  title: 'Faq', component: FaqPage },
            // {icon:"cart",  title: 'Other Product', component: OtherProductPage },
            // {icon:"cafe",  title: 'Offers', component: OffersPage },
            
            // {icon:"person",  title: 'PMAY', component: PmayPage },
            {icon:"../assets/icon/ico-static-lhs-calculators.svg",  title: 'Calculators', component: CalculatorsPage ,fn:"true"},
            
            // {icon:"../assets/icon/ico-static-lhs-refer-friend.svg",  title: "Refer A Friend", component: ReferAFriendPage},
             
            {icon:"../assets/icon/ico-static-lhs-logout.svg",  title: "Login", component: LoginPage},
           
           
          ];
        this.nav.setRoot(page.component);
        // window.location.Reload() 
      }else if(page.title=="Calculators"){
        if(localStorage.getItem("token")){
          this.nav.setRoot(page.component)
        }else{
          this.nav.setRoot(LoginPage,{"title":"Calculators"})
        }
      }else if(page.title=="Home"){
        if(localStorage.getItem("token")){
          this.nav.setRoot(page.component)
        }else{
          this.nav.setRoot(LoginPage,{"title":"Home"})
        }
      }
      else{
        this.presentModal()
      }
      
    }
    
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    
  }
  openCelusion(url){
    window.location.href=url;
  }
 
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts